<script setup lang="ts">
import { inject, onMounted, ref, type PropType } from "vue";
import type { UIColor } from "../../..";

const { color } = defineProps({
  /*
      Icon identifier
      See https://fonts.google.com/icons
    */
  id: {
    type: String,
    required: true,
  },

  /*
      Icon size
      values: small, medium, large, big, huge
    */
  size: {
    type: String as PropType<
      "small" | "medium" | "large" | "big" | "huge" | "control"
    >,
    required: true,
  },

  /*
      Icon color
      values: see src/css/color.css
    */
  color: {
    type: String as PropType<UIColor>,
    required: true,
  },

  /*
      Icon two-tone
    */
  twoTone: {
    type: Boolean,
    default: false,
  },
});

// Used to communicate color upwards to PushButton if it exists
const iconColor = inject("iconColor", ref<UIColor>());

onMounted(() => {
  iconColor.value = color;
});
</script>

<template>
  <span
    :class="[
      $style.container,
      `${twoTone ? 'i-tt-' : 'i-'}${id}`,
      $style[size],
    ]"
    :style="{ background: `var(${color})` }"
  />
</template>

<style>
@import "./assets/all.css";
</style>

<style module>
.container {
  display: inline-flex;
  flex-grow: 0;
  flex-shrink: 0;
  mask-position: center center;
  mask-repeat: no-repeat;
  mask-size: contain;
  user-select: none;
}

.container.small {
  width: calc(3rem / 4);
  height: calc(3rem / 4);
}

.container.medium {
  width: calc(4rem / 4);
  height: calc(4rem / 4);
}

.container.large {
  width: calc(5rem / 4);
  height: calc(5rem / 4);
}

.container.big {
  width: calc(8rem / 4);
  height: calc(8rem / 4);
}

.container.huge {
  width: calc(13rem / 4);
  height: calc(13rem / 4);
}

.container.control {
  width: calc(6rem / 4);
  height: calc(6rem / 4);
}
</style>
